import { useEffect, useMemo, useState } from "react";
import Seo from "@/components/Seo";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { ArtistChapter } from "@/components/ArtistChapter";
import { GalleryChapter } from "@/components/GalleryChapter";
import { WorldChapter } from "@/components/WorldChapter";
import { PracticeChapter } from "@/components/PracticeChapter";
import { RecognitionChapter } from "@/components/RecognitionChapter";
import { ExhibitionsChapter } from "@/components/ExhibitionsChapter";
import { ContactChapter } from "@/components/ContactChapter";
import { Footer } from "@/components/Footer";
import { fetchArtworks, fetchEvents, fetchSettings } from "@/lib/api";
import { ARTIST } from "@/lib/constants";
import { HOME, isHonour } from "@/lib/site";
import { homeSchema } from "@/lib/schema";
import { scrollToId, scrollTop } from "@/lib/smooth";

export default function Home() {
  const [artworks, setArtworks] = useState([]);
  const [events, setEvents] = useState([]);
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    fetchArtworks()
      .then(setArtworks)
      .catch(() => setArtworks([]));
    fetchEvents()
      .then(setEvents)
      .catch(() => setEvents([]));
    fetchSettings()
      .then((s) => {
        setSettings(s);
        if (s.version) localStorage.setItem("pk_site_v", String(s.version));
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (window.location.hash) {
      const t = setTimeout(() => scrollToId(window.location.hash.slice(1)), 500);
      return () => clearTimeout(t);
    }
    scrollTop(true);
    return undefined;
  }, []);

  const jsonLd = useMemo(homeSchema, []);

  const featured = artworks.filter((a) => a.featured);
  const heroWorks = featured.length ? featured : artworks.slice(0, 3);
  const honours = events.filter(isHonour);
  const journey = events.filter((e) => !isHonour(e));

  return (
    <div data-testid="home-page">
      <Seo
        title={HOME.title}
        siteName={ARTIST.name}
        description={HOME.description}
        image={HOME.image}
        imageAlt={`${ARTIST.name} at work among Mithila motifs`}
        jsonLd={jsonLd}
      />
      <Navbar />
      <main>
        <Hero featured={heroWorks} statement={settings?.hero_statement} />
        <Marquee />
        <ArtistChapter quote={settings?.artist_quote} />
        <GalleryChapter artworks={artworks} />
        <WorldChapter />
        <PracticeChapter />
        <RecognitionChapter honours={honours} />
        <ExhibitionsChapter events={journey} />
        <ContactChapter />
      </main>
      <Footer />
    </div>
  );
}
